import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/anc-client/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/anc-client/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/anc-client/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/root/anc-client/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Hanken_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"henkenGrotesk\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/anc-client/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/root/anc-client/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/anc-client/src/app/[locale]/components/Layout/index.tsx");
;
import(/* webpackMode: "eager" */ "/root/anc-client/src/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/anc-client/src/components/Store.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/root/anc-client/src/hooks/useTheme.tsx");
